import React from 'react';

import Chessground from 'react-chessground'
import 'react-chessground/dist/styles/chessground.css'

class Board extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }
  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.arrows !== prevProps.arrows && this.props.arrows.length === 0) {
      this.ref.current?.cg?.setAutoShapes([]);
    }
  }
  render () {
    const { fen, lastMove, onMove, orientation, movable } = this.props;
    const { arrows, arrowsEnabled, arrowsVisible } = this.props;
    const { check } = this.props;
    const turn = fen.split(' ')[1] === 'w' ? 'white' : 'black';

    const { width, height } = this.props;
    const style = {
      width: "100vw",
      height: "100vw",
      maxWidth: width || 600, // TODO: we sure a fixed number here is correct?
      maxHeight: height || 600, // TODO: we sure a fixed number here is correct?
    }
    return (
      <Chessground
        ref={this.ref}
        fen={fen || '8/8/8/8/8/8/8/8'}
        turnColor={turn}
        style={style}
        lastMove={lastMove}
        onMove={onMove}
        orientation={orientation}
        selectable={{ enabled: true }}
        movable={movable}
        drawable={{
          enabled: arrowsEnabled,
          visible: arrowsVisible,
          autoShapes: arrows.map(({ from, to, color }) => ({ orig: from, dest: to, brush: color || 'paleGrey' }))
        }}
        check={check ? turn : null}
      />
    );
  }
}

export default Board;
